<template>
  <Layout>
    <PageHeader :title="page.title" :items="page.items" />

    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <b-col lg="4">
              <b-form-group
                label="User Name"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="User-name"
              >
                <b-form-input
                  id="User-name"
                  v-model="search_condition.userName"
                  trim
                  placeholder="Please enter"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                label="Device Model"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="Device Users"
              >
                <b-form-select
                  v-model="search_condition.deviceModelId"
                  :options="types.deviceTypes"
                  value-field="id"
                  text-field="modelName"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                label="Carts Model"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="Mode-type"
              >
                <b-form-input
                  id="Mode-type"
                  v-model="search_condition.cartridgeModel"
                  trim
                  placeholder="Please enter"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                label="Use Time"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="Use-time"
              >
                <date-picker
                  v-model="searchTime"
                  format="MM/DD/YYYY"
                  range
                  append-to-body
                  lang="en"
                  placeholder="Select date"
                ></date-picker>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <!-- table -->
          <b-button
            v-has="'testRecord::Export'"
            @click="export_checkout"
            variant="primary"
            >Export</b-button
          >

          <div class="table-responsive mb-0">
            <b-table
              show-empty
              empty-text="no records"
              id="table"
              head-variant="light"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">
                {{
                  data.index +
                  (search_condition.pageNum - 1) * search_condition.pageSize +
                  1
                }}
              </template>

              <template v-slot:cell(actions)="row">
                <b-button-group>
                  <b-button
                    v-has="'testRecord::Details'"
                    size="sm"
                    variant="info"
                    @click="detail(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Details
                  </b-button>
                </b-button-group>
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination mb-0" v-if="rows != 0">
                  <b-pagination
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  >
                  </b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import timeZoneConversion from "@/components/widgets/timeZoneConversion";

/**
 * FAQ component
 */
export default {
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },
  data() {
    return {
      page: {
        title: "Test Record",
        items: [
          {
            text: "UNI-CORE",
            // href: "/"
          },
          {
            text: "Production Manage",
            // href: "/"
          },
          {
            text: "Test Record",
            active: true,
          },
        ],
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        {
          //使用客户
          key: "userName",
          label: "User Name",
          class: "text-center",
        },
        {
          //所属品牌商
          key: "brandName",
          label: "Brand",
          class: "text-center",
        },
        {
          //设备型号
          key: "deviceModel",
          label: "Device Model",
          class: "text-center",
        },
        {
          //固件版本
          key: "firmwareVersion",
          label: "Firmware",
          class: "text-center",
        },
        {
          //设备Mac
          key: "deviceNumber",
          label: "Device MAC",
          class: "text-center",
        },
        {
          //烟弹型号
          key: "cartridgeModel",
          label: "Carts Model",
          class: "text-center",
        },
        {
          //烟弹ID
          key: "cartridgeNumber",
          label: "Carts ID",
          class: "text-center",
        },
        {
          //使用时间
          key: "createTime",
          label: "Use Time",
          class: "text-center",
          formatter: (value) => {
            if (value) {
              return timeZoneConversion.getLocalTime(value);
            } else {
              return "";
            }
          },
        },
        { key: "actions", label: "Operation", class: "text-center" },
      ],
      searchTime: ["", ""], //查询时间
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        userName: "", //测试用户
        deviceModelId: "", //设备型号
        cartridgeModel: "", //烟弹型号
        startTime: "", //开始时间
        endTime: "", //结束时间
      },
      isBusy: false,
      has_data: false,
      types: {
        statuss: [
          { text: "Please select", value: "", disabled: false },
          { text: "Enabled", value: 0, disabled: false },
          { text: "Disabled", value: 1, disabled: false },
        ],
        deviceTypes: [{ modelName: "Please select", id: "", disabled: false }],
        allSupplier: [],
      },
    };
  },
  watch: {
    searchTime: function (val) {
      this.search_condition.startTime = val[0]
        ? timeZoneConversion.queryTime(val[0])
        : val[0];
      if (val[1]) {
        this.search_condition.endTime = timeZoneConversion.queryTime(
          val[1].getTime() + 24 * 3600 * 1000 - 1
        );
      } else {
        this.search_condition.endTime = val[1];
      }
    },
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {},
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$api.Dropdown.selectAllDeviceModel().then((res) => {
        if (res.success && res.data) {
          this.types.deviceTypes = this.types.deviceTypes.concat(res.data);
        } else {
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // 导出校验
    export_checkout() {
      //时间范围三个月内
      if (this.search_condition.createTime && this.search_condition.endTime) {
        let three = 90 * 24 * 3600 * 1000;
        let date = new Date(this.search_condition.endTime).getTime();
        let threeMonths = date - three;
        if (
          threeMonths > new Date(this.search_condition.createTime).getTime()
        ) {
          this.$bvToast.toast("Please select the time frame within 3 months");
          return;
        }
      }
      this.export_excel();
    },
    export_excel() {
      //导出Excel
      this.$api.warmUpMode.exportCartsData(this.search_condition);
    },
    provider(ctx) {
      this.isBusy = true;
      return this.$api.warmUpMode
        .developerDataList(this.search_condition, ctx)
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    detail(item, index, button) {
      this.$router.push("testRecordInfo?id=" + item.id);
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
    },
  },
};
</script>
